import { render, staticRenderFns } from "./AppSocialLinkedin.vue?vue&type=template&id=b1f9bd3a&scoped=true&"
import script from "./AppSocialLinkedin.vue?vue&type=script&lang=js&"
export * from "./AppSocialLinkedin.vue?vue&type=script&lang=js&"
import style0 from "./AppSocialLinkedin.vue?vue&type=style&index=0&id=b1f9bd3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f9bd3a",
  null
  
)

export default component.exports